export const MAIN_CLASS_NAME = 'project-card';
export const EXTRA_CLASS_NAME = `${MAIN_CLASS_NAME}__extra`;
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const FOOTER_CLASS_NAME = `${MAIN_CLASS_NAME}__footer`;
export const FOOTER_MODELS_CLASS_NAME = `${FOOTER_CLASS_NAME}__models`;

export const SOURCES_PAGE_SIZE = 5;

export const TRANSLATION_GROUP_PREFIX = 'Project: Card:';
